package org.matthewo.components

import emotion.react.css
import js.internal.InternalApi
import org.matthewo.hooks.useObserver
import org.matthewo.hooks.useStatefulRef
import org.matthewo.hooks.useWindowSize
import react.*
import react.dom.html.ReactHTML.div
import web.cssom.*
import web.dom.document
import web.html.HTMLElement

external interface FitTextProps : PropsWithClassName, PropsWithChildren

private const val MIN_FONT_SIZE = 50
private const val MAX_FONT_SIZE = 1_000

@OptIn(InternalApi::class)
val FitText = FC<FitTextProps> { props ->
    val (textParentRef, textParentRefCallback) = useStatefulRef<HTMLElement>()
    val (textRef, textRefCallback) = useStatefulRef<HTMLElement>()

    val windowSize = useWindowSize()
    var minTextFontSize by useState(MIN_FONT_SIZE)
    var maxTextFontSize by useState(MAX_FONT_SIZE)
    var textFontSize by useState((minTextFontSize + maxTextFontSize) / 2)
    useEffectOnce {
        document.fonts.ready.then { // TODO does this need to be cleaned up
            minTextFontSize = MIN_FONT_SIZE
            maxTextFontSize = MAX_FONT_SIZE
        }
    }
    useEffect(windowSize) {
        minTextFontSize = MIN_FONT_SIZE
        maxTextFontSize = MAX_FONT_SIZE
    }
    useObserver(
        textRef,
        childList = true,
        characterData = true,
        subtree = true,
    ) {
        minTextFontSize = MIN_FONT_SIZE
        maxTextFontSize = MAX_FONT_SIZE
    }
    useLayoutEffect(textParentRef, textRef, textFontSize, minTextFontSize, maxTextFontSize) {
        if (null == textParentRef || null == textRef) return@useLayoutEffect
        val (min, max) = if (
            textParentRef.getBoundingClientRect().width >= textRef.getBoundingClientRect().width &&
            textParentRef.getBoundingClientRect().height >= textRef.getBoundingClientRect().height
        ) {
            textFontSize to maxTextFontSize
        } else if (
            textParentRef.getBoundingClientRect().width < textRef.getBoundingClientRect().width ||
            textParentRef.getBoundingClientRect().height < textRef.getBoundingClientRect().height
        ) {
            minTextFontSize to textFontSize
        } else {
            minTextFontSize to maxTextFontSize
        }
        minTextFontSize = min
        maxTextFontSize = max
        textFontSize = (min + max) / 2
    }

    div {
        ref = textParentRefCallback
        css(props.className) {
            overflow = Overflow.hidden
            display = Display.grid
            gridTemplateRows = array(1.fr, Auto.auto, 1.fr)
        }

        div {
            ref = textRefCallback
            css {
                gridRow = integer(2)
                color = Globals.inherit
                display = Display.block
                fontSize = (textFontSize / 10.0).px
                textAlign = Globals.inherit
            }

            +props.children
        }
    }
}
